import environment from './environment';
import workspace from './workspace';
import repository from './repository';
import user from './user';
import userId from './userId';
import task from './task';
/** @type {import('../types').DataTypesConfig}*/

export default {
  environment: environment,
  workspace: workspace,
  repository: repository,
  user: user,
  userId: userId,
  task: task
};